import { useEffect, useRef, useState } from "react";

export function useCountUp(target: string, duration = 1800) {
  const [display, setDisplay] = useState("0");
  const [started, setStarted] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const numStr = target.replace(",", ".");
  const numeric = parseFloat(numStr.replace(/[^\d.]/g, "")) || 0;
  const suffix = numStr.replace(/[\d.]/g, "").replace(".", "");
  const isDecimal = target.includes(",") || target.includes(".");

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting && !started) setStarted(true); },
      { threshold: 0.5 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [started]);

  useEffect(() => {
    if (!started) return;
    let raf: number;
    const startTime = performance.now();

    function tick(now: number) {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = numeric * eased;

      if (isDecimal) {
        setDisplay(current.toFixed(1).replace(".", ",") + suffix);
      } else {
        setDisplay(Math.round(current) + suffix);
      }

      if (progress < 1) raf = requestAnimationFrame(tick);
    }

    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [started, numeric, suffix, isDecimal, duration]);

  return { display, ref };
}
